<button type="button"
    class="sheet-upload-btn"
    [class.sheet-upload-bar]="variant === 'bar'"
    [class.sheet-upload-icon]="variant === 'icon'"
    [class.drag-over]="dragOver"
    [disabled]="busy"
    title="Upload an Excel list. Purchase Manager searches each item and unit, then the Hyperpure cart is updated from the results."
    (click)="openPicker()"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave()"
    (drop)="onDrop($event)">
    <i class="material-icons">cloud_upload</i>
    <span class="sheet-upload-label"
        *ngIf="variant === 'bar'">Upload Excel</span>
</button>
<input #fileInput
    type="file"
    class="sheet-upload-input"
    accept=".xlsx,.xls,.csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,text/csv"
    (change)="onFileSelected($event)">

<ng-template #sheetModal>
    <div class="sheet-overlay"
        (click)="close()">
        <div class="sheet-modal"
            role="dialog"
            aria-modal="true"
            aria-label="Hyperpure Excel upload"
            (click)="$event.stopPropagation()">
            <div class="sheet-modal-head">
                <img src="assets/images/hyperpure_cart.png"
                    alt=""
                    class="sheet-logo">
                <div class="sheet-head-copy">
                    <h3>{{ phase === 'error' ? 'Check the sheet' : (phase === 'done' ? headline : 'Adding to Hyperpure') }}</h3>
                    <p>Item and unit have to match Hyperpure exactly. If the cart already has that quantity, it is left as it is.</p>
                </div>
                <button type="button"
                    class="sheet-close"
                    *ngIf="phase !== 'writing'"
                    (click)="close()"
                    aria-label="Close">
                    <i class="material-icons">close</i>
                </button>
            </div>

            <div class="sheet-progress"
                *ngIf="busy">
                <div class="sheet-progress-track">
                    <div class="sheet-progress-fill"
                        [style.width.%]="progressPercent"></div>
                </div>
                <div class="sheet-progress-meta">
                    <span>{{ label }}</span>
                    <span *ngIf="phase === 'matching'">{{ done }} / {{ total }}</span>
                </div>
            </div>

            <div class="sheet-error"
                *ngIf="phase === 'error'">
                <i class="material-icons">error_outline</i>
                <p>{{ errorMessage }}</p>
            </div>

            <div class="sheet-result"
                *ngIf="phase === 'done' && summary">
                <div class="sheet-stats">
                    <div class="sheet-stat"
                        *ngIf="summary.added > 0">
                        <strong>{{ summary.added }}</strong>
                        <span>Added</span>
                    </div>
                    <div class="sheet-stat"
                        *ngIf="summary.updated > 0">
                        <strong>{{ summary.updated }}</strong>
                        <span>Updated</span>
                    </div>
                    <div class="sheet-stat"
                        *ngIf="summary.already > 0">
                        <strong>{{ summary.already }}</strong>
                        <span>Already in cart</span>
                    </div>
                    <div class="sheet-stat sheet-stat-warn"
                        *ngIf="summary.notFound > 0">
                        <strong>{{ summary.notFound }}</strong>
                        <span>Not found</span>
                    </div>
                    <div class="sheet-stat sheet-stat-warn"
                        *ngIf="summary.failed > 0">
                        <strong>{{ summary.failed }}</strong>
                        <span>Not added</span>
                    </div>
                </div>

                <div class="sheet-groups">
                    <section *ngIf="lines('added').length">
                        <h4>Added</h4>
                        <div class="sheet-line"
                            *ngFor="let line of lines('added')">
                            <div>
                                <p class="sheet-line-name">{{ line.item }}</p>
                                <p class="sheet-line-meta">{{ line.unit }} · {{ line.quantity }} · {{ rowLabel(line) }}</p>
                            </div>
                            <span class="sheet-pill sheet-pill-ok">Added</span>
                        </div>
                    </section>

                    <section *ngIf="lines('updated').length">
                        <h4>Quantity updated</h4>
                        <div class="sheet-line"
                            *ngFor="let line of lines('updated')">
                            <div>
                                <p class="sheet-line-name">{{ line.item }}</p>
                                <p class="sheet-line-meta">{{ line.unit }} · {{ line.detail }}</p>
                            </div>
                            <span class="sheet-pill">{{ line.quantity }}</span>
                        </div>
                    </section>

                    <section *ngIf="issueLines().length">
                        <h4>Needs a look</h4>
                        <div class="sheet-line"
                            *ngFor="let line of issueLines()">
                            <div>
                                <p class="sheet-line-name">{{ line.item }}</p>
                                <p class="sheet-line-meta">{{ line.unit }}<ng-container *ngIf="rowLabel(line)"> · {{ rowLabel(line) }}</ng-container> · {{ line.detail }}</p>
                            </div>
                        </div>
                    </section>

                    <button type="button"
                        class="sheet-already-toggle"
                        *ngIf="lines('already').length"
                        (click)="showAlready = !showAlready">
                        {{ showAlready ? 'Hide' : 'Show' }} {{ lines('already').length }} already in the cart
                    </button>
                    <section *ngIf="showAlready">
                        <div class="sheet-line"
                            *ngFor="let line of lines('already')">
                            <div>
                                <p class="sheet-line-name">{{ line.item }}</p>
                                <p class="sheet-line-meta">{{ line.unit }} · {{ line.quantity }}</p>
                            </div>
                            <span class="sheet-pill">In cart</span>
                        </div>
                    </section>
                </div>

                <p class="sheet-footnote"
                    *ngIf="quietSkipCount > 0">
                    {{ quietSkipCount }} {{ quietSkipCount === 1 ? 'row had' : 'rows had' }} no quantity, so {{ quietSkipCount === 1 ? 'it was' : 'they were' }} left out.
                </p>
            </div>

            <div class="sheet-actions">
                <button type="button"
                    class="sheet-cancel"
                    *ngIf="phase === 'reading' || phase === 'matching'"
                    (click)="close()">Cancel</button>
                <button type="button"
                    class="sheet-done"
                    *ngIf="phase === 'done' || phase === 'error'"
                    (click)="close()">Done</button>
            </div>
        </div>
    </div>
</ng-template>
